



















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CommonModal extends Vue {
  @Prop({ type: Boolean }) disabledClose!: boolean
  @Prop({ type: String, default: '300' }) width!: string
}
